function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__a",
  x1: 635.65,
  y1: 790.5,
  x2: 635.65,
  y2: 501.26,
  gradientTransform: "translate(.01 -.01)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__b",
  x1: 457.34,
  y1: 294.83,
  x2: 457.34,
  y2: 145.49,
  xlinkHref: "#mobile-first-design_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__c",
  x1: 591.52,
  y1: 654.18,
  x2: 591.52,
  y2: 72.22,
  gradientTransform: "translate(-238.99 -72.23)",
  xlinkHref: "#mobile-first-design_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__d",
  x1: 771.88,
  y1: 599.91,
  x2: 771.88,
  y2: 322.65,
  xlinkHref: "#mobile-first-design_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__e",
  x1: 683.94,
  y1: 827.36,
  x2: 683.94,
  y2: 758.36,
  gradientTransform: "translate(-238.99 -72.23)",
  xlinkHref: "#mobile-first-design_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__f",
  x1: 432.87,
  y1: 501.19,
  x2: 432.87,
  y2: 377.79,
  xlinkHref: "#mobile-first-design_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__g",
  x1: 428.07,
  y1: 603.48,
  x2: 428.07,
  y2: 493.95,
  xlinkHref: "#mobile-first-design_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__h",
  x1: 352.52,
  y1: 380.93,
  x2: 352.52,
  y2: 201.04,
  xlinkHref: "#mobile-first-design_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile-first-design_svg__i",
  x1: 442.05,
  y1: 399.65,
  x2: 442.05,
  y2: 262.62,
  xlinkHref: "#mobile-first-design_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 361,
  cy: 395.57,
  r: 297,
  fill: "none",
  stroke: "#3ad29f",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  strokeDasharray: 12
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 361,
  cy: 395.57,
  r: 360,
  fill: "none",
  stroke: "#3ad29f",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  strokeDasharray: 12
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M840.94 582.47a81.21 81.21 0 00-161-15.14l-249.59-6.77 2.74 42.88s-35.59 82.12 151.46 104v83h216.24v-138a81.16 81.16 0 0040.15-69.97z",
  transform: "translate(-239 -72.21)",
  fill: "url(#mobile-first-design_svg__a)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M202.66 533.03s-34.08 78.64 145.05 99.62v79.52H554.8V501.58L200 491.96z",
  fill: "#be7c5e"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M545.16 277.07a38.18 38.18 0 01-52.5 11.93l-111.19-73.27a38.18 38.18 0 01-11.93-52.5A38.18 38.18 0 01422 151.3l111.19 73.27a38.18 38.18 0 0111.97 52.5z",
  transform: "translate(-239 -72.21)",
  fill: "url(#mobile-first-design_svg__b)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M300 200.86a35.49 35.49 0 01-48.8 11.09l-103.39-68.16a35.49 35.49 0 01-11.09-48.8 35.49 35.49 0 0148.8-11.09l103.37 68.12A35.49 35.49 0 01300 200.86z",
  fill: "#be7c5e"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 515.49,
  cy: 512.94,
  r: 77.77,
  fill: "#be7c5e"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 191.32,
  width: 322.42,
  height: 581.96,
  rx: 12.25,
  ry: 12.25,
  fill: "url(#mobile-first-design_svg__c)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 195.67,
  y: 7.87,
  width: 313.7,
  height: 566.24,
  rx: 13.64,
  ry: 13.64,
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M431.33 22.07a25.43 25.43 0 01-25.07 21.63H297.92a25.43 25.43 0 01-25.06-21.63h-57.4a11.91 11.91 0 00-11.92 11.91v514a11.91 11.91 0 0011.91 11.92h274.14a11.91 11.91 0 0011.92-11.91v-514a11.91 11.91 0 00-11.91-11.92z",
  fill: "#7ebc89"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 318.01,
  y: 28.84,
  width: 69.91,
  height: 4.37,
  rx: 2,
  ry: 2,
  fill: "#dbdbdb"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 402.77,
  cy: 30.59,
  r: 2.62,
  fill: "#dbdbdb"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M804.76 598.87c-22.57 5.22-38.06-9.5-43.28-32.06l-51.86-192.57a42.24 42.24 0 0131.55-50.51 42.24 42.24 0 0150.51 31.55L834 552.82c5.22 22.57-6.68 40.83-29.24 46.05z",
  transform: "translate(-239 -72.21)",
  fill: "url(#mobile-first-design_svg__d)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 739.86,
  y: 329.79,
  width: 70.78,
  height: 282.61,
  rx: 35.39,
  ry: 35.39,
  transform: "rotate(-13.01 339.366 1483.163)",
  fill: "#be7c5e"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#mobile-first-design_svg__e)",
  d: "M296.93 686.15h296v69h-296z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#4d8af0",
  d: "M304.93 694.15h280v54h-280z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M502 483.65a37.72 37.72 0 01-51.87 11.79l-74.57-48.25a37.72 37.72 0 01-11.79-51.87 37.72 37.72 0 0151.87-11.79l74.57 48.25A37.72 37.72 0 01502 483.65z",
  transform: "translate(-239 -72.21)",
  fill: "url(#mobile-first-design_svg__f)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M483.28 585.78a38.06 38.06 0 01-52.34 11.9L384.75 564a38.06 38.06 0 01-11.9-52.34 38.06 38.06 0 0152.34-11.9l46.19 33.69a38.06 38.06 0 0111.9 52.33z",
  transform: "translate(-239 -72.21)",
  fill: "url(#mobile-first-design_svg__g)"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 352.52,
  cy: 290.99,
  r: 89.94,
  fill: "url(#mobile-first-design_svg__h)",
  opacity: 0.5
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 352.52,
  cy: 290.99,
  r: 84.65,
  fill: "#69f0ae"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M315.78 279.69l31.74 29.1 44.97-66.13 15.88 13.23-60.85 79.36-44.97-50.26 13.23-5.3z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M240.55 511.06a35.49 35.49 0 01-48.8 11.09l-43.08-31.36a35.49 35.49 0 01-11.09-48.8 35.49 35.49 0 0148.8-11.09l43.07 31.42a35.49 35.49 0 0111.1 48.74zM258.9 408.79a35.49 35.49 0 01-48.8 11.09l-70.16-45.4a35.49 35.49 0 01-11.09-48.8 35.49 35.49 0 0148.8-11.09l70.16 45.4a35.49 35.49 0 0111.09 48.8z",
  fill: "#be7c5e"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M521.28 382a37.9 37.9 0 01-52.11 11.84l-94.5-61.53a37.9 37.9 0 01-11.84-52.11 37.9 37.9 0 0152.11-11.84l94.5 61.53A37.9 37.9 0 01521.28 382z",
  transform: "translate(-239 -72.21)",
  fill: "url(#mobile-first-design_svg__i)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M277.26 306.59a35.49 35.49 0 01-48.8 11.09l-88.51-57.63a35.49 35.49 0 01-11.09-48.8 35.49 35.49 0 0148.8-11.09l88.5 57.63a35.49 35.49 0 0111.1 48.8z",
  fill: "#be7c5e"
});

function SvgMobileFirstDesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 722,
    height: 756.57
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

export default "data:image/svg+xml;base64,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";
export { SvgMobileFirstDesign as ReactComponent };